module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-10.9c8dce74.png";